<template>
  <BaseButtonRectangle>
    <BaseText6 text="Continue as guest"/>
  </BaseButtonRectangle>
</template>

<script>
import BaseText6 from '@/components/BaseText6/BaseText6'
import BaseButtonRectangle from '@/components/BaseButtonRectangle/BaseButtonRectangle'
export default {
  components: {
    BaseText6,
    BaseButtonRectangle
  }
}
</script>
